import { generatePath } from 'react-router-dom';
import { transformPaginatedResponseFilters } from '../../../components/paginated-list/helper';
import { API_URLS } from '../../../routes/urls';
import { News, NewsListItem } from '../../../types/news';
import { PaginatedListParams, PaginatedListResponse } from '../../../types/util';
import { apiSlice } from '../../apiSlice';
import { QueryErrorReturnValue } from '../../types';
import { addSnackbar } from '../snackbar/snackbarSlice';

const newsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    latestFeaturedNews: builder.query<News[], void>({
      query: () => ({
        url: generatePath(API_URLS.latestFeaturedNews, { timeInSeconds: Math.floor(Date.now() / 1000).toString() }),
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          const err = error as QueryErrorReturnValue;
          dispatch(
            addSnackbar({
              message: err.error.message,
              severity: 'error',
            })
          );
        }
      },
    }),
    listNews: builder.query<PaginatedListResponse<NewsListItem>, PaginatedListParams | void>({
      query: (params) => ({
        url: API_URLS.news,
        params: {
          ...params,
          limit: 12,
        },
      }),
      transformResponse: (response: PaginatedListResponse<NewsListItem>) => transformPaginatedResponseFilters(response),
    }),
    singleNews: builder.query<News, string>({
      query: (newsSlug) => ({
        url: generatePath(API_URLS.singleNews, { newsSlug }),
      }),
    }),
  }),
});

export const { useLatestFeaturedNewsQuery, useListNewsQuery, useSingleNewsQuery } = newsApi;
